export const bonus_round_page = (t) => ({
	BONUS_WIN_TEXT: {
		value: t('bonus.total_win'),
		config: {
			fill: '#F3D501',
			fontFamily: 'Poppins SemiBold',
			fontSize: 25
		}
	},
	BONUS_WIN_VALUE: {
		value: '$0.00',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	},
	BONUS_HEART_TEXT: {
		value: '+10',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_HEART_SUBTEXT: {
		value: 'SPIN',
		config: {
			fontFamily: 'Japanese',
			fontSize: 20,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_STAR_TEXT: {
		value: '10X',
		config: {
			fontFamily: 'Japanese',
			fontSize: 40,
			fill: ['#EF9904', '#dd741d']
		}
	},
	BONUS_STAR_SUBTEXT: {
		value: 'MULT',
		config: {
			fontFamily: 'Japanese',
			fontSize: 24,
			fill: ['#EF9904', '#dd741d']
		}
	}
});
